import type { CSSProperties } from 'react'
import { parseSku, formatSku, DEFAULT_SKU_UNIT } from '@/utils/skuFormat'

interface SkuInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

const inputStyle: CSSProperties = {
  fontFamily: 'Lexend Deca',
  fontSize: '12px',
  height: '40px',
  border: '1px solid #E9E9EA',
  borderRadius: '8px',
  paddingLeft: '16px',
  paddingRight: '44px',
}

const unitStyle: CSSProperties = {
  fontFamily: 'Lexend Deca',
  fontSize: '12px',
  color: '#69697A',
  pointerEvents: 'none',
}

const SkuInput = ({ value, onChange, placeholder = '1250' }: SkuInputProps) => {
  const { amount, prefix } = parseSku(value)

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/[^\d.]/g, '')
    const parts = raw.split('.')
    const sanitized =
      parts.length > 2 ? `${parts[0]}.${parts.slice(1).join('')}` : raw
    onChange(formatSku(sanitized, DEFAULT_SKU_UNIT, prefix) ?? '')
  }

  return (
    <div className="relative w-full">
      <input
        type="text"
        inputMode="decimal"
        value={amount}
        onChange={handleAmountChange}
        placeholder={placeholder}
        className="w-full focus:outline-none focus:ring-2 focus:ring-primary-500"
        style={inputStyle}
        aria-label={`SKU weight in ${DEFAULT_SKU_UNIT}`}
      />
      <span
        className="absolute right-3 top-1/2 -translate-y-1/2"
        style={unitStyle}
      >
        {DEFAULT_SKU_UNIT}
      </span>
    </div>
  )
}

export default SkuInput
